import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { GroupProtectedRoute } from '../../components/auth/GroupProtectedRoute';
import { FEATURE_GROUPS } from '../../features.config';
import { DeficitsPage } from './pages/DeficitsPage';
import { DeficitsReportPage } from './pages/DeficitsReportPage';

export const DeficitsRoutes: React.FC = () => (
  <GroupProtectedRoute requiredGroup={FEATURE_GROUPS.deficits}>
    <Routes>
      <Route index element={<DeficitsPage />} />
      <Route path="report" element={<DeficitsReportPage />} />
    </Routes>
  </GroupProtectedRoute>
);
